var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIq(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 411,
    height: 274,
    viewBox: "79.461 52.641 411 274",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M79.501 139.356h410.998v101.287H79.501z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#CF2029",
    d: "M79.5 53h410.998v91.288H79.5z",
    style: {
      fill: "#ce1126",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#020202",
    d: "M79.5 235.713h410.998V327H79.5z",
    style: {
      fill: "#000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#119B4A",
    style: {
      fill: "#007a3d",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#007a3d",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M325.525 173.177c-.558-.294-1.186-.767-1.395-1.053-.314-.439-.131-.456 1.163-.105 2.319.629 3.815.384 5.298-.872l1.308-1.103 1.54.784c.848.428 1.748.724 2.008.656.667-.176 2.05-1.95 2.005-2.564-.054-.759.587-.569.896.263.615 1.631-.281 3.503-1.865 3.918-.774.202-1.488.127-2.659-.28-1.439-.502-1.684-.495-2.406.057-1.617 1.24-3.869 1.356-5.893.299zM331.258 167.935c-.563-.716-1.239-3.423-1.02-4.088.192-.575.39-.69.914-.526.918.287 1.13.92.993 3.063-.107 1.748-.366 2.207-.887 1.551z",
    style: {
      fill: "#007a3d",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M263.743 165.991c-.185 1.31 2.325 4.567 3.458 5.157-.77.345-1.728.189-2.434.577-3.948 3.948-18.367 18.005-21 21.366 7.799.154 16.449-.106 23.761-.44-.007-5.299 5.018-5.573 8.381-7.503 1.73 2.725 6.075 2.516 6.618 6.618 0 4.91.009 12.306.009 17.646h-66.625c-1.172 5.176-5.844 9.125-12.354 7.5 2.014-2.103 5.406-2.827 6.619-5.734 1.025-6.365-2.045-10.296-4.031-13.907 3.284-1.195 3.782-1.493 7.121-3.737-2.343 7.12 6.091 6.338 12.353 6.175.211-2.417.089-5.271-1.766-5.624 2.396-.87 2.794-1.168 6.619-4.412v9.592c14.886 0 30.943-.111 46.139-.111 0-3.002.795-7.824-1.581-7.824-2.269 0-.107 6.173-1.87 6.173h-35.63c0-1.328-.034-4.104-.034-6.104 1.51-1.511 1.331-1.38 11.648-11.698 1.028-1.029 8.266-7.567 14.599-13.71zM352.803 165.737c2.488 1.338 4.457 3.191 7.502 3.971-.353 1.26-1.475 1.759-1.769 3.087v26.91c3.402.75 4.118-1.178 5.737-2.205.442 4.307 3.185 8.53 3.088 11.91h-14.559l.001-43.673zM333.391 180.149s5.296-4.471 5.296-4.643v23.485l3.814-.006c0-8.948-.118-18.023-.118-26.338 1.548-1.549 4.58-3.792 5.338-5.359v42.059c-10.746 0-30.793.013-33.443.013-.493-8.73-.577-17.771 9.599-15.827v-3.562c-.31-.609-.868.147-.998-.645 1.616-1.617 2.163-2.029 6.538-5.851 0 4.612.081 15.499.081 15.499 1.07 0 3.153.004 3.857.004.001.001.036-18.228.036-18.829zm-12.554 18.602c.716 1.075 3.155 1.056 3.04-.755-.411-1.493-3.615-.924-3.04.755z",
    style: {
      fill: "#007a3d",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 224.026,
    cy: 214.369,
    r: 2.042,
    style: {
      fill: "#007a3d",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.048 165.779c2.488 1.339 4.457 3.191 7.502 3.971-.353 1.26-1.476 1.759-1.768 3.087v26.911c3.401.749 4.117-1.179 5.736-2.206.441 4.307 3.185 8.529 3.088 11.91h-14.559l.001-43.673z",
    style: {
      fill: "#007a3d",
      fillOpacity: 1
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIq);
export default __webpack_public_path__ + "static/media/iq.f1009620ef6cb2a84de197fe912cacd0.svg";
export { ForwardRef as ReactComponent };